import { useMemo } from "react";
import Button from "src/Components/Button/Button";
import { OSType } from "src/Utils/Hooks/ManageAppReleases/useGetAppReleasesInfo";
import { logger } from "src/Utils/LoggerService/LoggerService";

interface IDownloadAppProps {
    osType: OSType;
    appSetupUrl: string;
    iskol: boolean | undefined;
    text: string;
}
const DownloadAApp: React.FC<IDownloadAppProps> = ({ appSetupUrl, iskol, osType, text }) => {

    const disableAppStoreButton = useMemo(() => {
        return !appSetupUrl || (osType !== OSType.Windows && iskol);
    }, [iskol, appSetupUrl, osType]);
    return (
        <a
            href={appSetupUrl}

            target={(osType === OSType.Windows) ? "" : '_blank'}
            rel="noOpener noReferrer"
            style={{
                cursor: 'pointer',
                display: 'block',
                pointerEvents: disableAppStoreButton ? 'none' : 'auto'
            }}
        >

            <Button
                backgroundColor="var(--primary-translucent)"
                color="var(--primary-color)"
                text={text}
                borderColor="none"
                fontSize="13px"
                width='127px'
                disable={disableAppStoreButton}
                onClick={() => { logger.logInformation(`User accessed ${(osType)} app from portal.`) }}
            />

        </a>
    );
}

export default DownloadAApp;